import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import CssBaseline from '@mui/material/CssBaseline';
import { lightMode } from './theme';
import { ThemeProvider } from '@mui/material';

// Dynamic viewport height for Safari
const setViewportHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
};

setViewportHeight();

window.addEventListener('resize', setViewportHeight);

window.addEventListener('orientationchange', () => {
    setTimeout(setViewportHeight, 100);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
        <CssBaseline />
        <ThemeProvider theme={lightMode}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </ThemeProvider>
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
